import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Filter, TableItem } from '../models/table';
import { HttpClient } from '@angular/common/http';
import { YearlySkillsDto } from './api.service';

interface SkillResponse {
  skill_id: number;
  skill_name: string;
  skill_description: string;
  skill_group_id: number;
  g_name: string;
}

@Injectable({
  providedIn: 'root',
})
export class TableService {
  private readonly http = inject(HttpClient);

  getSkills(): Observable<SkillResponse[]> {
    return this.http.get<SkillResponse[]>('/api/v1/skills');
  }

  getData(filter?: Filter): Observable<TableItem[]> {
    return this.http.post<TableItem[]>('/api/v1/grid', JSON.stringify(filter));
  }

  getUserSkillsByYear(acronym: string): Observable<YearlySkillsDto[]> {
    return this.http.get<YearlySkillsDto[]>(
      `/api/v1/grid/user-skills/${acronym}`
    );
  }
}
